import React from "react";
import { GridPreferencePanelsValue, useGridApiContext } from "@mui/x-data-grid";
import {
    SovosMenuItem,
    SovosToolbarActions,
    SovosToolbarColumn,
    SovosToolbarDropdown,
    SovosToolbarFilter,
    SovosToolbarGroup,
} from "mosaic-react";
import { useGlobalValue } from "colbi_web_ui/lib/state/GlobalProvider";

const STATUS_FILTERS = [
    { label: "Status", value: "All" },
    { label: "Active", value: "Active" },
    { label: "Inactive", value: "Inactive" },
    { label: "Processing", value: "Processing" },
];

const RulesToolbar = ({ defaultToolbarProps, toolbarProps }) => {
    const { i18n } = useGlobalValue();
    const {
        filterArray,
        isFilterPanelOpen,
        isPreferencesPanelOpen,
    } = defaultToolbarProps || {};
    const { onStatusFilterChange, statusFilter } = toolbarProps || {};
    const gridRef = useGridApiContext();

    const toggleColumnPanel = () => {
        if (isPreferencesPanelOpen) {
            gridRef.current.hidePreferences();
        } else {
            gridRef.current.showPreferences(GridPreferencePanelsValue.columns);
        }
    };
    const toggleFilterPanel = () => {
        if (isFilterPanelOpen) {
            gridRef.current.hideFilterPanel();
        } else {
            gridRef.current.showFilterPanel();
        }
    };
    const appliedFiltersCount = (filterArray || []).reduce(
        (count, item) => count + (item?.filters?.length || 0),
        0,
    );

    return (
        <SovosToolbarGroup
            sx={{
                alignItems: "center",
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <SovosToolbarDropdown
                aria-label={i18n`Status`}
                onChange={(event) => onStatusFilterChange(event.target.value)}
                sx={{ minWidth: 140 }}
                value={statusFilter}
            >
                {STATUS_FILTERS.map(({ label, value }) => (
                    <SovosMenuItem key={value} value={value}>
                        {i18n(label)}
                    </SovosMenuItem>
                ))}
            </SovosToolbarDropdown>
            <SovosToolbarActions>
                <SovosToolbarColumn onClick={toggleColumnPanel} />
                <SovosToolbarFilter
                    appliedFiltersCount={appliedFiltersCount}
                    onClick={toggleFilterPanel}
                />
            </SovosToolbarActions>
        </SovosToolbarGroup>
    );
};

export default RulesToolbar;
